{
  "appName": "Apply for automobile or adaptive equipment online",
  "rootUrl": "/forms/21-4502/apply-automobile-and-adaptive-equipment",
  "entryName": "21-4502",
  "entryFile": "./app-entry.jsx",
  "productId": "",
  "template": {
    "vagovprod": false,
    "layout": "page-react.html",
    "includeBreadcrumbs": false,
    "minimalExcludePaths": [
      "/introduction",
      "/confirmation"
    ],
    "minimalFooter": true,
    "minimalHeader": {
      "title": "Apply for automobile allowance and adaptive equipment online",
      "subtitle": "(VA Form 21-4502)"
    }
  }
}
